// semeia-disable-reexport
import type MedicModel from "parog-web/models/medic";
import type Patient from "parog-web/models/patient";

export function possibleTypes(patient?: Patient, medic?: MedicModel): string[] {
  let coreTypes = [
    "recurring-monitoring-point",
    "pps-control-treatment",
    "pps-control-biology",
    "pps-control-consultations",
    "pps-control-exams",
    "pps-control-vital-constants",
    "bio-exams-missing",
    "bio-exams-received",
    "collect-tls-consent"
  ];

  const mentalTypes = [
    "ponctual-monitoring-point",
    "dashboard-monitoring",
    "call-patient",
    "home-support",
    "call-psychiatrist",
    "call-treating-physician",
    "bio-exams-missing"
  ];

  const oncoTypes = [
    "planify-follow-up-first-results",
    "follow-up-first-results",
    "planify-follow-up-remission",
    "follow-up-remission",
    "planify-follow-up-monitoring",
    "follow-up-monitoring",
    "planify-pharmaceutical-interview",
    "pharmaceutical-interview",
    "visit-call",
    "administrative",
    "incoming-patient-call",
    "incoming-health-professional-call",
    "post-reconstruction-call",
    "outgoing-patient-call",
    "outgoing-health-professional-call",
    "cp-patient-appointment",
    "room-visit",
    "patient-visit",
    "internal-meeting",
    "external-meeting",
    "professional-appointment",
    "biological-assessment-ecbu",
    "biological-analysis",
    "biological-assessment-psa",
    "medical-consultation",
    "measure-vital-sign-weight",
    "measure-vital-sign-blood-pressure",
    "measure-vital-sign-temperature",
    "re-evaluation-scanner"
  ];

  const digestTypes = [
    "recurring-monitoring-point",
    "pps-control-treatment",
    "bio-exams-missing"
  ];

  const isgtTasks = [
    "pre-operating-call",
    "post-operating-call",
    "request-cs-post-operating-date",
    "post-operating-consultation-call",
    "recovery-pps-oncology",
    "visit-call",
    "chemotherapy-point",
    "pps-radiotherapy-call",
    "start-radiotherapy-call",
    "end-radiotherapy-call",
    "j-30-call",
    "j-90-call",
    "j-180-call",
    "j-365-call",
    "end-targeted-therapy-call"
  ];

  const oncoToulouseTasks = [
    "inter-treatment-survey",
    "pre-treatment-survey",
    "pre-surgery-survey",
    "post-surgery-survey",
    "ctcae-survey",
    "anxiety-survey",
    "satisfaction-survey"
  ];

  if (patient) {
    const areaId = patient.therapeuticalArea?.id;

    if (areaId == "mental") return mentalTypes;

    if (areaId == "onco") {
      let oncoTasks = coreTypes.concat(oncoTypes);

      if (patient.healthCentre?.oncoToulouse) {
        oncoTasks = oncoTasks.concat(oncoToulouseTasks);
      }

      if (patient.healthCentre?.isgt) {
        oncoTasks = oncoTasks.concat(isgtTasks);
      }

      return oncoTasks;
    }

    if (areaId == "digest") return digestTypes;

    return coreTypes;
  }

  const medicTherapeuticalAreaIds = medic?.therapeuticalAreaIds;

  if (medicTherapeuticalAreaIds?.includes("onco")) {
    coreTypes = coreTypes.concat(oncoTypes);
    if (medic?.healthCentres.some(hc => hc.isgt)) {
      coreTypes = coreTypes.concat(isgtTasks);
    }
    if (medic?.healthCentres.some(hc => hc.oncoToulouse)) {
      coreTypes = coreTypes.concat(oncoToulouseTasks);
    }
  }
  if (medicTherapeuticalAreaIds?.includes("mental")) {
    coreTypes = coreTypes.concat(mentalTypes);
  }

  return coreTypes;
}
